/** The project's own channels — the landing footer and the support window link to them. */
export const SOCIAL_LINKS = {
	TELEGRAM: "https://t.me/STN_bible_study",
	YOUTUBE: "https://www.youtube.com/@-CTH-",
} as const;
